import type { MeAccessResponse } from './types'

// Layer-2 fine permissions (apps/accounts/idp.yaml `resources:` catalog) that
// gate the dashboard surfaces. Each id is `accounts.{resource}.{verb}`, one
// verb per real operation the resource declares — these mirror what the
// admin API enforces server-side; the SPA uses them only to hide navigation
// and actions the caller cannot use.
export const Permission = {
  customers: {
    get: 'accounts.customers.get',
    list: 'accounts.customers.list',
    create: 'accounts.customers.create',
    update: 'accounts.customers.update',
  },
  users: {
    get: 'accounts.users.get',
    list: 'accounts.users.list',
    create: 'accounts.users.create',
    update: 'accounts.users.update',
    delete: 'accounts.users.delete',
  },
  roles: {
    get: 'accounts.roles.get',
    list: 'accounts.roles.list',
    create: 'accounts.roles.create',
    update: 'accounts.roles.update',
    delete: 'accounts.roles.delete',
  },
  serviceAccounts: {
    get: 'accounts.serviceAccounts.get',
    list: 'accounts.serviceAccounts.list',
    create: 'accounts.serviceAccounts.create',
    update: 'accounts.serviceAccounts.update',
    delete: 'accounts.serviceAccounts.delete',
  },
  accountSettings: {
    get: 'accounts.accountSettings.get',
    update: 'accounts.accountSettings.update',
  },
} as const

// True when the caller's access carries the given permission. A null access
// (still loading, or the me/access probe failed) grants nothing; an access
// response missing the permissions field is treated the same way rather than
// throwing.
export function hasPermission(access: MeAccessResponse | null, permission: string): boolean {
  return access != null && (access.permissions ?? []).includes(permission)
}
